import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-iqacminutes',
  templateUrl: './iqacminutes.component.html',
  styleUrls: ['./iqacminutes.component.scss']
})
export class IqacminutesComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
